module.exports = __webpack_public_path__ + "static/Topshows_Logo-4ee6b96c9505e3c2977ecbe961b9ed51.png";